import { WSList } from "@wingspanhq/fe-component-library";
import {
  RequirementDefinitionTemplate,
  RequirementDefinitionTemplateTier
} from "../types";
import { Section } from "./Section";
import { useQueryExtendedRequirementDefinitions } from "../../../../../query/requirementDefinitions/query/useQueryExtendedRequirementDefinitions";
import { WSQueries } from "../../../../../query/WSQuery";

type Props = {
  tiers: RequirementDefinitionTemplateTier[];
  onSelect: (item: RequirementDefinitionTemplate) => void;
  selected: RequirementDefinitionTemplate | null;
};

export const List: React.FC<Props> = props => {
  const queryRequirementDefinitions =
    useQueryExtendedRequirementDefinitions("contextType");

  return (
    <WSQueries queries={{ queryRequirementDefinitions }}>
      {({ queryRequirementDefinitionsData }) => (
        <WSList gap="2XL">
          {props.tiers.map(tier => (
            <Section
              requirements={queryRequirementDefinitionsData}
              key={tier}
              tier={tier}
              onSelect={props.onSelect}
              selected={props.selected}
            />
          ))}
        </WSList>
      )}
    </WSQueries>
  );
};
